import axios from '../../../../api/axios';
import React, {useState,useEffect} from 'react'
import {EyeFill,PencilFill,Trash3Fill,HouseAddFill} from "react-bootstrap-icons"
import { useNavigate } from 'react-router-dom';
import loadingIcon from '../../../../Images/loading.gif'
import Swal from 'sweetalert2';

function Ecole(){
    const navigate=useNavigate()
    const [ecoles,setEcoles]=useState([])
    const [loading,setLoading]=useState(false)
    const [curentpage,setCurentpage]=useState(1)
    const [npperpage,setNbrperpage]=useState(20)
    const [inspections,setInspections]=useState([])
    const lastIndex=npperpage * curentpage
    const firstIndex=lastIndex-npperpage
    let inspectionName="" 
    const [search,setSearch]=useState('')
   // const records=search.toLowerCase() === '' ? ecoles.slice(firstIndex,lastIndex) : ecoles.filter((ecole)=>{return ecole.nom.toLowerCase().includes(search)}).slice(firstIndex,lastIndex)
    const records= search.toLowerCase() === '' ? ecoles.slice(firstIndex, lastIndex) : ecoles.filter((ecole)=>{return search.toLowerCase() === '' ? ecole : ecole?.nom?.toLowerCase()?.includes(search)})?.slice(firstIndex, lastIndex)
    useEffect(()=>{
            HandleRequest()
        HandleRequestInspection()
    },[])
     const HandleRequestInspection=async()=>{
            await axios.get('/api/Inspection').then((res)=>{
                setInspections(res.data.items)
            }).catch((err)=>{
                
            })
        }
    const HandleRequest=async()=>{
        setLoading(true)

        await axios.get('api/ecole').then((res)=>{
            setLoading(false)
           
            setEcoles(res.data.items)
        }).catch((err)=>{
	console.error(err)      
  })
    }
    function Iteration(){
        return loading ? (
            <div className='w-100 mx-auto'>
              <center>  <img src={loadingIcon} alt='loading' className='align-middle'/></center>
            </div>
        )   : (
            
            records.filter((ecole)=>{
                return search.toLowerCase() === '' ? ecole : ecole?.nom?.toLowerCase()?.includes(search)
        //const searchTerm = search.toLowerCase();
        // Sécurisation du nom de l'école pour le filtrage
        //const nomEcole = ecole?.nom ? ecole.nom.toLowerCase() : "";
        //return searchTerm === '' ? true : nomEcole.includes(searchTerm);    
	}).map((ecole,indexV)=>
            {
              return(
                    <tr key={indexV} className='ligne'>
                        <td>{indexV+1}</td>
                        <td>{ecole.nom || 'Sans nom'}</td>
                        <td>{ecole?.myinspection?.province || 'Non fourni'}</td>

                        <td>{ecole?.myinspection?.province_educationnelle || 'Non défini'}</td>                        
                        <td>{ecole.ville}</td>
                        <td>{ecole.adresse || 'Non défini'}</td>

                        <td>{ecole.Numero_agreement}</td>
                        <td>{ecole?.ecole_admin?.eleve?.prenom + ' ' + ecole?.ecole_admin?.eleve?.nom || 'Aucun'}</td>
                        <td>{ecole?.ecole_admin?.eleve?.telephone}</td>
                        <td>{ecole.etat}</td>
                        <td><EyeFill color="lightgreen" size={20} className='d-inline-flex mx-2 icone'  /><PencilFill color="royalblue" size={20} className='d-inline-flex mx-2 icone' onClick={()=>navigate(`${ecole.id}`)}/>  <Trash3Fill color='brown' size={20} className='d-inline-flex mx-2 icone' onClick={()=>AlertNotification(ecole.id)} /> </td>
                    </tr>
              )
                
            }
            )
        
    )
        
       }
       function AlertNotification(idecole){
        Swal.fire({
            title:'Suppression d\'une école ',
            text:'Etes-vous de vouloir supprimer cette école ?',
            icon:'warning',
            showDenyButton:true,
            showCancelButton:true,
            confirmButtonText:'Confirmer',
            denyButtonText:'Annuler'
        }).then((resultat)=>{
            if(resultat.isConfirmed){
                navigate(`/ecole/suppression/${idecole}`)
                    }
        })
    }

    return(
        <>
    <div className="bg-primary text-light py-3 px-3 shadow-sm mb-4">
    <div className="container-fluid">
        <div className="row align-items-center g-3">
            {/* Titre et Compteur */}
            <div className="col-12 col-md-6">
                <h4 className="mb-0 fw-bold">
                    Liste des écoles <span className="badge bg-white text-primary ms-2">{ecoles.length}</span>
                </h4>
            </div>
            
            {/* Recherche et Bouton Ajouter */}
            <div className="col-12 col-md-6 d-flex flex-column flex-sm-row gap-2 justify-content-md-end">
                <input 
                    type="text" 
                    placeholder="Rechercher une école..." 
                    className="form-control w-100 w-sm-auto shadow-sm"
                    value={search} 
                    onChange={(e) => setSearch(e.target.value.toLowerCase())} 
                />
                <button 
                    onClick={() => navigate('insertion')} 
                    className="btn btn-success d-flex align-items-center justify-content-center gap-2 shadow-sm"
                >
                    <HouseAddFill color='white' size={20} />
                    <span>Ajouter une école</span>
                </button>
            </div>
        </div>
    </div>
    <div className="container-fluid px-4 mt-2">
    {/* VUE TABLEAU (Visible uniquement sur Desktop) */}
    <div className="d-none d-lg-block table-responsive shadow-sm rounded">
        <table className="table table-hover align-middle bg-white">
            <thead className="table-dark text-nowrap">
                <tr>
                    <th>#</th>
                    <th>Ecole</th>
                    <th>Province</th> {/* Regroupement pour gagner de la place */}
                    <th>Prov. Éducationnelle</th>
                    <th>Ville</th>
                    <th>Adresse</th>
                    <th>N°Agrément</th>
                    <th>Administrateur</th>
                    <th>Téléphone</th>
                    <th>État</th>
                    <th className="text-center">Actions</th>
                </tr>
            </thead>
            <tbody>
                {/* Vos lignes de données ici */}
                {Iteration()} 
            </tbody>
        </table>
    </div>

    {/* VUE CARTES (Visible uniquement sur Mobile/Tablette) */}
    <div className="d-block d-lg-none">
        <div className="row g-3">
            {ecoles.filter(e => e.nom.includes(search)).map((ecole, index) => (
                <div key={index} className="col-12 col-md-6">
                    <div className="card shadow-sm border-0 h-100">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h5 className="card-title fw-bold text-primary mb-0">{ecole.nom}</h5>
                                <span className="badge bg-info">{ecole.etat}</span>
                            </div>
                            <p className="card-text small text-muted mb-1">
                                <strong>Ville:</strong> {ecole.ville} | {ecole.province}
                            </p>
                            <p className="card-text small mb-2">
                                <strong>Admin:</strong> {ecole.administrateur} ({ecole.telephone})
                            </p>
                            <div className="d-flex gap-2">
                                <button className="btn btn-sm btn-outline-primary w-100">Détails</button>
                                <button className="btn btn-sm btn-outline-danger">Supprimer</button>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
</div>

</div>

         </>
    )
}
export default Ecole

